import React from "react";
import {
  Row,
  Col,
  Input,
  Select,
  Pagination,
  DatePicker,
  Upload,
  Button,
  Table,
  message,
  Popover,
  Modal,
  Spin,
  Tag,
} from "antd";
import common from "@/public/common";
import "../returnGoods/index.less";
import { ajaxApi, netExport, fileDownloadApiNew, downloadApi } from "@/server";
import {
  tokenConfig,
  getCookie,
  getCookieNew,
  getSid,
  outformat,
  getModerId,
} from "../../public/utils";
import _, { debounce, get, set, takeRight } from "lodash";
import moment from "moment";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;
const host = window.location.host;
const urlLink = common.scpUrl + "change-stack";
class DeliverList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sping: false,
      row: [],
      data: [],
      pageNo: 1,
      pageSize: 15,
      total: 0,
      //以下为新
      search: {},
      statusList: [],
      whidList: [],
      isModalOpen: false,
    };
  }
  componentDidMount() {
    // 默认查询前一个月的数据
    let _search = this.state.search;
    _search.BeginTime = moment(new Date())
      .subtract(1, "months")
      .format("YYYY-MM-DD");
    _search.EndTime = moment(new Date()).format("YYYY-MM-DD");
    this.setState(
      {
        search: _search,
      },
      () => {
        this.getStatus();
        this.getList();
      }
    );
  }
  // 获取查询发货单状态信息、仓库信息
  getStatus = () => {
    ajaxApi({
      url: urlLink + "/Supplier",
      params: {
        action: "getdictionarybytypekey",
        data: {
          TypeKey: "DeliveryStatus",
          s_code: getCookieNew("supplier_code")
            ? getCookieNew("supplier_code")
            : null,
        },
      },
    }).then((res) => {
      if (res.data.error_code === 0) {
        this.setState({
          statusList: res.data.data,
        });
      } else {
        message.error("获取状态失败");
      }
    });
    ajaxApi({
      url: urlLink + "/WareHouse",
      params: { action: "getwarehouseforsale" },
    }).then((res) => {
      if (res.data.error_code === 0) {
        this.setState({
          whidList: res.data.data,
        });
      } else {
        message.error("获取状态失败");
      }
    });
  };
  // 获取列表信息--完成
  getList = () => {
    this.setState(
      {
        sping: true,
      },
      () => {
        let param = {
          ...this.state.search,
          AdminID: getCookie("supplierinfo")
            ? JSON.parse(getCookie("supplierinfo")).user_id
            : null,
          s_code: getCookieNew("supplier_code")
            ? getCookieNew("supplier_code")
            : null,
        };
        ajaxApi({
          url: urlLink + "/Purchase",
          params: {
            action: "getsupplierdeliverylist",
            pageIndex: this.state.pageNo,
            pageSize: this.state.pageSize,
            data: param,
          },
        }).then((res) => {
          if (res.data.error_code === 0) {
            this.setState({
              total: res.data.total_count,
              data: res.data.data,
              sping: false,
            });
          } else {
            message.error(res.data.error_message);
          }
        });
      }
    );
  };
  // 搜索条件input框值更改
  inputChange = (name, val) => {
    let _obj = this.state.search;
    _obj[name] = val.target.value;
    this.setState({
      search: _obj,
    });
  };
  // 搜索条件单据类型更改值
  selectChange = (name, val) => {
    let _obj = this.state.search;
    _obj[name] = val;
    this.setState({
      search: _obj,
    });
  };
  // 时间选择
  changTime = (name, val) => {
    let _info = this.state.search;
    _info[name] = val ? moment(val).format("YYYY-MM-DD") : val;
    this.setState({
      search: _info,
    });
  };
  // 搜索
  search = () => {
    this.setState(
      {
        row: [],
        selectedRowKeys: [],
        pageNo: 1,
        current: 1,
        pageSize: 15,
      },
      () => {
        this.getList();
      }
    );
  };
  reset = () => {
    this.setState(
      {
        row: [],
        selectedRowKeys: [],
        search: {
          BeginTime: moment(new Date())
            .subtract(1, "months")
            .format("YYYY-MM-DD"),
          EndTime: moment(new Date()).format("YYYY-MM-DD"),
        },
      },
      () => {
        this.getList();
      }
    );
  };
  // 导出
  export = () => {
    fileDownloadApiNew({
      url: urlLink + "/deliveryExport",
      param: {
        ...this.state.search,
        action: "getdeliverylistexport",
        AdminID: getCookie("supplierinfo")
          ? JSON.parse(getCookie("supplierinfo")).user_id
          : null,
        delivery_code_list:
          this.state.row.length > 0
            ? this.state.row.map((e) => e.delivery_code.replace("L", "F"))
            : [],
        s_code: getCookieNew("supplier_code")
          ? getCookieNew("supplier_code")
          : null,
      },
      filename: "发货单" + moment(new Date()).format("YYYYMMDD") + ".xls",
    }).then((res) => {});
  };
  //随货同行单导出
  deliveryExcel = async () => {
    const { row } = this.state;
    if (row.length === 0) {
      message.error("请选择要导出的发货单");
      return;
    }
    fileDownloadApiNew({
      url:
        common.scpUrl + "supplier-delivery-scs/export-batch-delivery-excel",
      param: {
        deliver_id_list: row.map((e) => e.delivery_id),
        service: "scs",
        s_code: getCookieNew("supplier_code")
          ? getCookieNew("supplier_code")
          : null,
      },
      filename: "随货同行单" + moment(new Date()).valueOf("x") + ".xlsx",
    }).then((res) => {});
  };
  // 撤销发货
  revoke = (name, item) => {
    let param = {};
    if (name === "more") {
      if (this.state.row.length > 0) {
        for (let i = 0; i < this.state.row.length; i++) {
          if (this.state.row[i].status_name !== "已预约") {
            message.error("发货单非预约状态无法撤销");
            return false;
          }
        }
        param = {
          deliveryIds: this.state.row
            .map((item) => {
              return item.delivery_id;
            })
            .join(","),
        };
      } else {
        message.error("请选择发货单");
        return false;
      }
    } else {
      param = {
        deliveryIds: item.delivery_id,
      };
    }
    ajaxApi({
      url: urlLink + "/cancel-delivery",
      params: {
        action: "canceldeliverynew",
        data: param,
      },
    }).then((res) => {
      if (res.data.flag === true) {
        message.success("撤销成功!");
        this.getList();
      } else {
        message.error(res.data.message);
      }
    });
  };
  // 跳转单据详情
  goDetails = (name, item) => {
    if (name === "deliver") {
      // 发货单跳转
      window.open(
        "http://" +
          host +
          "/deliverDetails?DeliveryID=" +
          item.delivery_id +
          "&DeliveryCode=" +
          item.delivery_code
      );
    } else {
      // 订单编号跳转
      let param = {
        POCode: item.split(",")[1],
        Type: "",
        AdminID: getCookie("supplierinfo")
          ? JSON.parse(getCookie("supplierinfo")).user_id
          : null,
        s_code: getCookieNew("supplier_code")
          ? getCookieNew("supplier_code")
          : null,
      };
      ajaxApi({
        // 带订单编号去查询订单状态
        url: urlLink + "/Purchase",
        params: {
          pageIndex: 1,
          pageSize: 15,
          action: "getpurchaseforsupplierlist",
          data: param,
        },
      }).then((res) => {
        if (res.data.error_code === 0) {
          if (typeof res.data.data !== "string") {
            if (
              res.data.data[0].status_for_supplier_name === "待发货" ||
              res.data.data[0].status_for_supplier_name === "部分发货"
            ) {
              window.open(
                "http://" +
                  host +
                  "/waitBuyOrderDetails?POID=" +
                  item.split(",")[0] +
                  "&code=" +
                  item.split(",")[1]
              );
            } else {
              window.open(
                "http://" +
                  host +
                  "/main/orderAdmin/buyOrderDetails?POID=" +
                  item.split(",")[0] +
                  "&code=" +
                  item.split(",")[1]
              );
            }
          } else {
            message.error("没有相关订单");
          }
        } else {
          message.error(res.data.error_message);
        }
      });
    }
  };
  // 打印随货同行单
  print = (item) => {
    window.open("http://" + host + "/withPrint?DeliveryID=" + item.delivery_id);
  };
  // 表格分页
  pageOnChange = (val) => {
    this.setState(
      {
        pageNo: val,
      },
      () => {
        this.getList();
      }
    );
  };
  sizeOnchange = (current, size) => {
    this.setState(
      {
        pageNo: current,
        pageSize: size,
      },
      () => {
        this.getList();
      }
    );
  };

  openChangeDate = (record) => {
    this.setState({
      isModalOpen: true,
      modalParams: {
        ...record,
        expectDate: get(record, "ExpectDate")
          ? moment(get(record, "expect_date"))
          : null,
      },
    });
  };
  changeDate = (expectDate) => {
    let { modalParams } = this.state;
    set(modalParams, "expectDate", expectDate);
    this.setState({ modalParams });
  };
  handleOk = async () => {
    let { modalParams } = this.state;
    var { expectDate } = modalParams;
    var expectDateLong = moment(expectDate).valueOf();
    if (!expectDate) {
      message.error("请选择预计到货日期");
      return;
    }
    if (expectDateLong < moment().startOf("day")) {
      message.error("预计到货日期不能小于今天！");
      return;
    }
    this.setState(
      {
        changeLoading: true,
      },
      () => {
        this.changeDateAxios(expectDateLong);
      }
    );
  };

  changeDateAxios = async (expectDateLong) => {
    let { modalParams } = this.state;
    try {
      let res = await ajaxApi({
        url:
          common.scpUrl + "supplier-delivery-scs/update-delivery-expect-date",
        params: {
          delivery_code: get(modalParams, "delivery_code"),
          expect_date: expectDateLong,
          mod_time: moment().valueOf(),
          moder: 10,
        },
      });
      if (res.status == 200) {
        message.success("修改成功！");
        setTimeout(() => {
          this.getList();
          this.handleCancel();
        }, 1500);
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleCancel = () => {
    this.setState({
      isModalOpen: false,
      modalParams: {},
      changeLoading: false,
    });
  };

  downloadUdiTemplate = () => {
    downloadApi(
      common.scpUrl + "order/download-udi-annex-template",
      null,
      "UDI附件导入模板.xls"
    );
  };

  handleVisibleChange = (newVisible, key) => {
    let { visibleObj } = this.state;
    this.setState({
      visibleObj: { ...visibleObj, [key]: newVisible },
    });
  };

  getPersonProps = (key) => {
    return {
      name: "file",
      action: common.scpUrl + "order/upload-udi-annex",
      headers: { ...tokenConfig },
      data: (file) => {
        return {
          admin_id: getModerId(),
          delivery_code: get(this.state.selectedRowKeys, "0"),
          file,
          sid: getSid(),
        };
      },
      accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
      beforeUpload: (file) => {
        if (
          ![
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "application/vnd.ms-excel",
          ].includes(file.type)
        ) {
          message.error("请上传excel文件！");
        }
        return [
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
        ].includes(file.type)
          ? true
          : Upload.LIST_IGNORE;
      },
      onChange: (info) => {
        this.setState({ loading: { ...this.state.loading, uploadBtn: true } });

        if (info.file.status !== "uploading") {
          console.log(info.file, info.fileList);
        }
        if (info.file.status === "done") {
          var code = get(info, "file.response.code");
          if (code == "0") {
            message.success(`${info.file.name}导入成功`);
            this.getList();
            this.setState({
              visibleObj: { ...this.state.visibleObj, udiImport: false },
              loading: { ...this.state.loading, uploadBtn: false },
              selectedRowKeys: [],
            });
          }
          this.setState({
            loading: { ...this.state.loading, uploadBtn: false },
          });
        } else if (info.file.status === "error") {
          message.error(`${info.file.name}导入失败`);
          this.setState({
            loading: { ...this.state.loading, uploadBtn: false },
          });
        }
      },
    };
  };
  render() {
    const {
      num,
      data,
      total,
      sping,
      search,
      statusList,
      whidList,
      modalParams,
    } = this.state;
    const columns = [
      {
        title: "发货单号",
        dataIndex: "delivery_code",
        width: 250,
        render: (text, record) => (
          <div style={{ position: "relative" }}>
            <a onClick={this.goDetails.bind(this, "deliver", record)}>
              {text.replace("L", "F")}
            </a>
            {text.includes("-") && (
              <Tag style={{ marginLeft: "4px" }} color="green">
                历史订单
              </Tag>
            )}
          </div>
        ),
      },
      {
        title: "订单编号",
        dataIndex: "po_code",
        render: (text) => (
          <a onClick={this.goDetails.bind(this, "order", text)}>
            {text ? text.split(",")[1] : "--"}
          </a>
        ),
      },
      {
        title: "是否代发",
        dataIndex: "is_supplier_delivery",
        width: 90,
        render: (text, record) => <span>{text ? "是" : "否"}</span>,
      },
      {
        title: "仓库",
        dataIndex: "wh_name",
        render: (text) => <span>{outformat(text)}</span>,
      },
      {
        title: "发货时间",
        dataIndex: "delivery_time",
        render: (text) => (
          <span>{text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : ""}</span>
        ),
      },
      {
        title: "预计到货日期",
        dataIndex: "expect_date",
        render: (text, record) => (
          <span>
            {text ? moment(text).format("YYYY-MM-DD") : ""}
            {get(record, "status_name") == "已预约" && (
              <a
                onClick={this.openChangeDate.bind(this, record)}
                style={{ marginLeft: 4 }}
              >
                修改
              </a>
            )}
          </span>
        ),
      },
      {
        title: "发货数量",
        dataIndex: "delivery_quantity",
      },
      {
        title: "收货数量",
        dataIndex: "in_stock_quantity",
      },
      {
        title: "状态",
        dataIndex: "status_name",
        render: (text) => (
          <span>
            {text === "已预约" || text === "已签收" ? (
              <span style={{ color: "#8BC826" }}>{text}</span>
            ) : (
              <span>{text}</span>
            )}
          </span>
        ),
      },
      {
        title: "操作",
        render: (text, record) => {
          return (
            <div>
              {
                // !record.IsSupplierDelivery&&
                !record.is_supplier_delivery && (
                  <a onClick={this.print.bind(this, record)}>打印随货同行单</a>
                )
              }
              <a
                style={{
                  marginLeft: "4px",
                  display:
                    record.status_name === "已预约" &&
                    !record.is_supplier_delivery
                      ? "inline-block"
                      : "none",
                }}
                onClick={this.revoke.bind(this, "alone", record)}
              >
                撤销发货
              </a>
              {
                <a
                  style={{ marginLeft: "16px" }}
                  onClick={() => {
                    window.open(
                      "/deliverDetails?DeliveryID=" +
                        record.delivery_id +
                        "&DeliveryCode=" +
                        record.delivery_code +
                        "&Files=true"
                    );
                  }}
                >
                  发货附件导入
                </a>
              }
            </div>
          );
        },
      },
    ];
    const rowSelection = {
      selectedRowKeys: this.state.selectedRowKeys,
      // 分页选择项合并
      onChange: (selectedRowKeys, selectedRows) => {
        let _row = _.concat(
          JSON.parse(JSON.stringify(this.state.row)),
          selectedRows
        );
        _row = _.uniqWith(_row, _.isEqual);
        let _rows = [];
        if (this.state.row.length !== 0) {
          selectedRowKeys.map((item) => {
            if (
              _row.findIndex((e) => {
                return e.delivery_code === item;
              }) >= 0
            ) {
              _rows.push(
                _row[
                  _row.findIndex((e) => {
                    return e.delivery_code === item;
                  })
                ]
              );
            }
          });
        } else {
          _rows = _row;
        }
        this.setState({
          row: _rows,
          selectedRowKeys: selectedRowKeys,
        });
      },
    };
    return (
      <div className="returnList">
        <Spin spinning={sping}>
          <div className="search">
            <Row style={{ marginBottom: "25px" }}>
              <Col span={5}>
                <label
                  style={{
                    width: "70px",
                    display: "inline-block",
                    textAlign: "right",
                  }}
                >
                  {" "}
                  单 号：
                </label>
                <Input
                  placeholder="请输入发货单号或订单编号"
                  style={{ width: "70%" }}
                  onChange={this.inputChange.bind(this, "DeliveryCode")}
                  value={search.DeliveryCode}
                />
              </Col>
              <Col span={5}>
                <label>商品、货品：</label>
                <Input
                  placeholder="商品（货品）名称、编码"
                  style={{ width: "70%" }}
                  onChange={this.inputChange.bind(this, "ItemCode")}
                  value={search.ItemCode}
                />
              </Col>
              <Col span={5}>
                <label>发货单状态：</label>
                <Select
                  placeholder="请选择"
                  style={{ width: "70%" }}
                  onSelect={this.selectChange.bind(this, "Status")}
                  value={search.Status}
                >
                  <Option value="">全部</Option>
                  {statusList.map((item) => {
                    return (
                      <Option key={item.dict_key} value={item.dict_key}>
                        {item.dict_name}
                      </Option>
                    );
                    // return <Option value={item.dictkey}>{item.dictname}</Option>
                  })}
                </Select>
              </Col>
              <Col span={7}>
                <label>发货时间：</label>
                <DatePicker
                  value={
                    search.BeginTime
                      ? moment(search.BeginTime, "YYYY-MM-DD")
                      : ""
                  }
                  onChange={this.changTime.bind(this, "BeginTime")}
                />{" "}
                至{" "}
                <DatePicker
                  value={
                    search.EndTime ? moment(search.EndTime, "YYYY-MM-DD") : ""
                  }
                  onChange={this.changTime.bind(this, "EndTime")}
                />
              </Col>
            </Row>
            <Row>
              <Col span={5}>
                <label
                  style={{
                    width: "70px",
                    display: "inline-block",
                    textAlign: "right",
                  }}
                >
                  仓库：
                </label>
                <Select
                  placeholder="请选择"
                  style={{ width: "70%" }}
                  onSelect={this.selectChange.bind(this, "WHID")}
                  value={search.whid}
                >
                  <Option value="">全部</Option>
                  {whidList.map((item) => {
                    return (
                      <Option key={item.whid} value={item.whid}>
                        {item.name}
                      </Option>
                    );
                    // return <Option value={item.whid}>{item.name}</Option>
                  })}
                </Select>
              </Col>

              <Col span={5}>
                <label>&nbsp;&nbsp;&nbsp;&nbsp;是否代发：</label>
                <Select
                  placeholder="请选择"
                  style={{ width: "70%" }}
                  onSelect={this.selectChange.bind(this, "IsSupplierDelivery")}
                  value={search.Category}
                >
                  <Option value={null}>全部</Option>
                  <Option value={1}>是</Option>
                  <Option value={0}>否</Option>
                </Select>
              </Col>

              <Col span={10}>
                <Button type="primary" shape="round" onClick={this.search}>
                  查询
                </Button>
                <Button
                  style={{ marginLeft: "15px" }}
                  shape="round"
                  onClick={this.reset}
                >
                  重置
                </Button>
                <Button
                  style={{ marginLeft: "15px" }}
                  shape="round"
                  onClick={this.export}
                >
                  导出
                </Button>
                <Button
                  style={{ marginLeft: "15px" }}
                  shape="round"
                  onClick={this.revoke.bind(this, "more")}
                >
                  撤销发货
                </Button>
                <Button
                  disabled={this.state.row.length === 0}
                  onClick={() => {
                    this.deliveryExcel();
                  }}
                  style={{ marginLeft: "15px" }}
                  shape="round"
                >
                  导出随货同行单
                </Button>
              </Col>
            </Row>
          </div>
          <div className="returnBody">
            <Table
              columns={columns}
              dataSource={data}
              rowSelection={rowSelection}
              pagination={false}
              rowKey={(record) => record.delivery_code}
            />
            <div className="pagination">
              <span className="datanum">{"共" + total + "条数据"}</span>
              <Pagination
                showQuickJumper
                showSizeChanger
                current={this.state.pageNo}
                total={total}
                pageSize={this.state.pageSize}
                pageSizeOptions={["15", "20", "30", "50", "100"]}
                onChange={this.pageOnChange}
                onShowSizeChange={this.sizeOnchange}
              />
            </div>
          </div>
        </Spin>
        <Modal
          title="修改预计到货日期"
          open={this.state.isModalOpen}
          onCancel={this.handleCancel}
          footer={[
            <Button onClick={this.handleCancel}>取消</Button>,
            <Button
              type="primary"
              style={{ marginLeft: "12px" }}
              onClick={this.handleOk}
              loading={this.state.changeLoading}
            >
              提交
            </Button>,
          ]}
        >
          <div>
            预计到货日期：
            <DatePicker
              value={get(modalParams, "expectDate")}
              disabledDate={(current) => {
                return current && current < moment().startOf("day");
              }}
              onChange={this.changeDate}
            />
          </div>
        </Modal>
      </div>
    );
  }
}
export default DeliverList;



// WEBPACK FOOTER //
// ./src/pages/deliverGoods/deliverList.js